import { postMailing } from '../api/postMailing';
import { setGetMailing } from './setGetMailing';

export const setPostMailing = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await postMailing(params);
            alert('Сохранено')

            dispatch(setGetMailing({
                page: 1,
                pageSize: 25
            }))

            if (callback) {
                callback();
            }
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}